export enum EnvNames {
  prod = 'prod',
  staging = 'staging',
  dev = 'dev',
  local = 'local',
}
